import {apiService} from '../apiService';
import type {Contract, DocumentTemplate, GenerateDocumentRequest} from 'shared-types';

export const contractApi = {
    // GET routes
    getAll: (): Promise<Contract[]> =>
        apiService.get('/contract'),

    getEndingSoon: (days?: number): Promise<Contract[]> =>
        apiService.get(`/contract/ending-soon${days ? `?days=${days}` : ''}`),

    getByCustomerId: (customerId: string): Promise<Contract[]> =>
        apiService.get(`/contract/customer/${customerId}`),

    getById: (contractId: string): Promise<Contract> =>
        apiService.get(`/contract/${contractId}`),

    // POST routes
    create: (contract: Partial<Contract>): Promise<Contract> =>
        apiService.post('/contract', contract),

    createDocument: (document: GenerateDocumentRequest): Promise<DocumentTemplate> =>
        apiService.post('/contract/documents', document),

    createOrUpdateWithDocument: (customerId: string, data: {
        contract: Partial<Contract>;
        document: GenerateDocumentRequest
    }): Promise<Contract> =>
        apiService.post(`/contract/customer/${customerId}/document`, data),

    // PATCH/PUT routes
    update: (contractId: string, contract: Partial<Contract>): Promise<Contract> =>
        apiService.patch(`/contract/${contractId}`, contract),

    updateDocument: (contractId: string, document: GenerateDocumentRequest): Promise<DocumentTemplate> =>
        apiService.put(`/contract/${contractId}/document`, document),

    // File upload routes
    uploadDocuments: (formData: FormData): Promise<any> =>
        apiService.uploadFormData('/contract/documents', formData),

    // DELETE routes
    delete: (contractId: string): Promise<void> =>
        apiService.delete(`/contract/${contractId}`),

    deleteDocument: (customerId: string): Promise<void> =>
        apiService.delete(`/contract/documents/${customerId}`),
};